import { render, staticRenderFns } from "./LocalesCombo.vue?vue&type=template&id=d827b6da&"
import script from "./LocalesCombo.vue?vue&type=script&lang=js&"
export * from "./LocalesCombo.vue?vue&type=script&lang=js&"
import style0 from "./LocalesCombo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports